import "vue-wysiwyg/dist/vueWysiwyg.css";
import "toastr/build/toastr.min.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.core.css";
import "quill/dist/quill.bubble.css";
import "@/assets/scss/custom/_theme.scss";
import "@/assets/scss/main.scss";

import Vue from "vue";
import router from "./router";
import store from "@/store/index";
import BootstrapVue from "bootstrap-vue";
import VueSweetalert2 from "vue-sweetalert2";
import vuescroll from "vue-scroll";
import VeeValidate from "vee-validate";
import wysiwyg from "vue-wysiwyg";
import IconBase from "@/components/IconBase";
import VueSelect from "vue-select";
import "./registerServiceWorker";
import App from "./App.vue";
import axios from "./helpers/axios";
import apiBase from "./helpers/base";
import socket, { tenant } from "./plugins/socket";
import "./plugins/filters";
import { VueEditor } from "vue2-editor";
import { Plugin } from "vue-fragment";

const toastr = require("toastr");

Vue.use(BootstrapVue);
Vue.use(VueSweetalert2);
Vue.use(wysiwyg, {});
Vue.use(VeeValidate, {
  classes: true,
  errorBagName: "veeErrors",
  classNames: {
    valid: "is-valid",
    invalid: "is-invalid"
  },
  fieldsBagName: "veeFields"
});
Vue.use(vuescroll);
Vue.use(Plugin);
Vue.component("vue-editor", VueEditor);
Vue.component("icon-base", IconBase);
Vue.component("v-select", VueSelect);

// TODO: Disable devtools on production
Vue.config.productionTip = false;

Vue.prototype.$toastr = toastr;
Vue.prototype.$tenant = tenant;
Vue.prototype.$socket = socket;
Vue.prototype.$http = axios;
Vue.prototype.$api = apiBase;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
